<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/S8imX2/tc-custom/9781423607748.jpg?1736956274360" alt="This image is the cover for the book Pocket Guide to Brilliance"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pocket Guide to Brilliance
      </h1>
      <p class="bookDescription body article font2">
        <b>The author of <i>Dad Humor</i> offers an entertaining look at American history’s geniuses, leaders, and dunderheads in a clever quest to define brilliance.</b><br/>  <br/> With dry humor and a wealth of fascinating trivia, Bart King explores what it means for a person to be brilliant. What he discovers is that brilliant people are those who walk farther, think deeper, and talk louder than the rest of us. They do what it takes to get the job done—and then some.<br/>  <br/> The masters of brilliance profiled here include presidential candidate John Lindsay, who released chickens into his opponent’s crowd to spur on a debate; the first female journalist, Anne Newport Royall, who forced an interview with John Quincy Adams after catching him skinny dipping; and Benjamin Franklin, who of course coined the phrase "A penny saved is a penny earned," but also offered the lesser known "A man who lives on hope, dies farting."
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bart King
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?03972dc4